import React from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from './CookieBanner';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export default function LanguageLayout() {
  const { lang } = useParams();
  const { i18n, t } = useTranslation();

  useEffect(() => {
    if (!lang) return;
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.setAttribute('lang', lang);
    document.title = t('meta.title');
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', t('meta.description'));
  }, [lang, i18n, t]);

  if (lang !== 'it' && lang !== 'en') return <Navigate to="/it" replace />;

  return (
    <div className="auro-app">
      <Header />
      <main className="auro-main">
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
